import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOffer } from '../../../types/offer';

import * as styles from './index.css';

export interface ILandStatusContext {
  offer: IOffer;
}

type TLandStatus =
  'individualHousingConstruction' |
  'farm' |
  'gardening' |
  'industrialLand' |
  'countryhouseNonCommercialPartnership' |
  'investmentProject';

const LandStatuses = {
  countryhouseNonCommercialPartnership: 'countryhouseNonCommercialPartnership' as TLandStatus,
  farm: 'farm' as TLandStatus,
  gardening: 'gardening' as TLandStatus,
  individualHousingConstruction: 'individualHousingConstruction' as TLandStatus,
  industrialLand: 'industrialLand' as TLandStatus,
  investmentProject: 'investmentProject' as TLandStatus,
};

const LansStatusName = {
  [LandStatuses.individualHousingConstruction]: 'ИЖС',
  [LandStatuses.farm]: 'Фермерское хозяйство',
  [LandStatuses.gardening]: 'Садоводство',
  [LandStatuses.industrialLand]: 'Земля промназначения',
  [LandStatuses.countryhouseNonCommercialPartnership]: 'ДНП',
  [LandStatuses.investmentProject]: 'Инвестпроект',
};

export class LandStatus extends React.Component {
  public context: ILandStatusContext;

  public static contextTypes = {
    offer: PropTypes.object,
  };

  public render() {
    const isLand = this.context.offer.category && this.context.offer.category.indexOf('land') >= 0;

    if (!isLand) {
      return null;
    }

    let landStatus: string | undefined;

    if (this.context.offer.land && this.context.offer.land.status) {
      landStatus = LansStatusName[this.context.offer.land.status];
    }

    if (landStatus) {
      return (
        <div className={styles['land-status']}>
          {landStatus}
        </div>
      );
    }

    return null;
  }
}
